// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type AstatDailyLocalTaxInfoFragmentFragment = { __typename?: 'AstatDailyLocalTaxInfoDTO', month: number, monthClosed: boolean, totalArrivals: number, totalDepartures: number, totalGuestsPresent: number, totalTaxAdults: number, totalTaxChildren: number, totalTaxExempted: number, year: number };

export const AstatDailyLocalTaxInfoFragmentFragment = gql`
    fragment AstatDailyLocalTaxInfoFragment on AstatDailyLocalTaxInfoDTO {
  month
  monthClosed
  totalArrivals
  totalDepartures
  totalGuestsPresent
  totalTaxAdults
  totalTaxChildren
  totalTaxExempted
  year
}
    `;
/* eslint-enable */